// docs/25 D9: which encounters' post-encounter (Spoils) screens this browser has moved on from.
// Client-only and per session: a reload shows the screen again while the encounter is the route's.
// docs/84: also which of my heroes the Spoils panel and its bar are choosing a pile for.
import { create } from 'zustand';

interface SpoilsStore { done: string[]; forHero?: string; seen(encounterId: bigint): boolean; markDone(encounterId: bigint): void; setForHero(heroId: string): void }

export const useSpoils = create<SpoilsStore>()((set, get) => ({
  done: [],
  seen(encounterId) { return get().done.includes(encounterId.toString()); },
  markDone(encounterId) { if (!get().seen(encounterId)) set({ done: [...get().done, encounterId.toString()] }); },
  setForHero(forHero) { set({ forHero }); },
}));
